// src/modals/MinStayDefaultEditModal.jsx — Phase 6.B PR #167c (ADR-101)
//
// Wrapper modal pour MinStayDefaultEditor (Vue 2 tableau Paramètres col 9).
//
// Pattern standard (LPRcv2-3 fix) :
//   - Esc keyboard → onClose (calque PricingConfigEditModal:135-142)
//   - Click overlay → onClose
//   - Click body → stopPropagation
//
// Body délégué à MinStayDefaultEditor mode="modal" (avec bouton Annuler).

import { useEffect } from 'react';
import { Ruler, Info } from 'lucide-react';
import { DS } from '../lib/ui';
import MinStayDefaultEditor from '../components/MinStayDefaultEditor';

/**
 * @param {{ logementId: string, logementLabel?: string, onClose: () => void, onSaved?: () => void }} props
 */
export default function MinStayDefaultEditModal({
  logementId,
  logementLabel,
  onClose,
  onSaved,
}) {
  // LPRcv2-3 — Esc keyboard handler (calque ResaV2Modal / PricingConfigEditModal)
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      data-testid="min-stay-default-edit-modal-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,.5)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        fontFamily: DS.fontBody,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        data-testid="min-stay-default-edit-modal-container"
        className="fbz-modal-sheet"
        style={{
          background: DS.card,
          borderRadius: DS.radiusCard,
          maxWidth: 560,
          width: '100%',
          maxHeight: '92vh',
          overflowY: 'auto',
          padding: 22,
        }}
      >
        <div style={{ marginBottom: 14 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontFamily: DS.fontDisplay,
              fontSize: 18,
              fontWeight: 600,
              color: DS.marineDark,
            }}
          >
            <Ruler size={18} strokeWidth={2.2} /> Min nuits défaut
          </div>
          <div style={{ fontSize: 12, color: DS.textMuted, marginTop: 4 }}>
            {logementLabel ? `${logementLabel} · ` : ''}
            <code>{logementId}</code>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            gap: 8,
            fontSize: 12,
            color: DS.marineDeep,
            background: DS.cielSoft,
            padding: '10px 12px',
            borderRadius: 8,
            marginBottom: 14,
            lineHeight: 1.5,
          }}
        >
          <Info size={15} strokeWidth={2.2} style={{ flexShrink: 0, marginTop: 2 }} />
          <span>Définit le nombre minimum de nuits par défaut pour ce logement (envoyé
          à Beds24 room.minStay). Les overrides per-date (cellules amber
          dans le calendrier) restent prioritaires.</span>
        </div>

        <MinStayDefaultEditor
          logementId={logementId}
          mode="modal"
          onCancel={onClose}
          onSaved={() => {
            onSaved?.();
            // Pas de fermeture auto : laisser user voir le toast success.
          }}
        />
      </div>
    </div>
  );
}
